import React from 'react';
import BookingPreview from './BookingPreview'
import StatusDot from './StatusDot'
import bookingsWithoutStaff from '../helpers/bookings_without_staff'
import bookingsForDate from '../helpers/bookings_for_date'


const UnassignedCell = ({ date, eventBookings, onClickBooking }) => {
  const currentBookings = bookingsForDate(date, bookingsWithoutStaff(eventBookings))

  return (
    <td>
      { currentBookings.map((booking) => (
        <div className="mb-1" key={booking.id}>
          <BookingPreview booking={booking} className="small" onClick={onClickBooking} />
        </div>
      ))}
    </td>
  )
}
export default UnassignedCell
